module.exports = __webpack_public_path__ + "static/media/vip-access-store-tile-1-promo.c6fac446.png";